  // src/components/Header.js
import React from 'react';
import { Link } from 'react-router-dom';
import SearchBar from './SearchBar';
import DarkModeToggle from './DarkModeToggle';

function Header() {
  return (
    <>
    <header className="bg-gradient-to-r from-orange-500 to-cyan-500 tex t-white shadow-2xl">    
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="w-12 h-12 bg-white rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
              <span className="text-2xl font-bold bg-gradient-to-r from-orange-500 to-cyan-500 bg-clip-text text-transparent">
                ∑
              </span>
            </div>
            <div>
              <h2 className="text-3xl font-bold bg-gradient-to-r from-white to-cyan-100 bg-clip-text text-transparent">
                CalcBlog
              </h2>
              <p className="text-orange-100 text-sm">Calculators & Insights</p>
            </div>
          </Link>
          
          <nav className="flex space-x-8">
            <Link 
              to="/" 
              className="nav-link text-white hover:text-orange-200 font-semibold text-lg transition-all duration-300 hover:scale-105"
            >
              Home
            </Link>
            <Link to="/articles" className="text-white hover:text-orange-200 font-semibold text-lg">
              Articles
            </Link>
            <Link 
              to="/calculators" 
              className="nav-link text-white hover:text-cyan-200 font-semibold text-lg transition-all duration-300 hover:scale-105"
            >
              Calculators
            </Link>
            <Link 
              to="/aboutus" 
              className="nav-link text-white hover:text-cyan-200 font-semibold text-lg transition-all duration-300 hover:scale-105"
            >
              About Us
            </Link>
          </nav>

           {///* Add Search and Dark Mode here 
          }
            <div className="flex items-center space-x-4">
              <SearchBar />
              <DarkModeToggle />
            </div>
        </div>
         <div className="grid grid-cols-3 md:grid-cols-3 gap-4 mt-8">
            <div className="flex justify-center">
              <img
                src="/images/calculator5.png"   
                alt="Carbon Calculator"   
                className="w-28 h-28 sm:w-32 sm:h-32 md:w-48 md:h-48 rounded-full object-cover border-4 border-white shadow-lg hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="flex justify-center">
              <img
                src="/images/calculator6.png" 
                alt="Budget Calculator"   
                className="w-28 h-28 sm:w-32 sm:h-32 md:w-48 md:h-48 rounded-full object-cover border-4 border-white shadow-lg hover:scale-105 transition-transform duration-300"
              />
            </div>
            {/*<div className="flex justify-center">
              <img
                src="/images/calculator3.png" 
                alt="Calorie Calculator"   
                className="w-48 h-48 rounded-full object-cover border-4 border-white shadow-lg hover:scale-105 transition-transform duration-300"
              />
            </div>*/}
            <div className="flex justify-center">
              <img
                src="/images/calculator4.png" 
                alt="BMI Calculator"   
                className="w-28 h-28 sm:w-32 sm:h-32 md:w-48 md:h-48 rounded-full object-cover border-4 border-white shadow-lg hover:scale-105 transition-transform duration-300"
              />
            </div>
          </div>
 
       </div> 
     </header>     
    </>
  );
}

export default Header;